import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('PrincipalInvitedEntity', PrincipalInvitedEntityData);

    PrincipalInvitedEntityData.$inject = ['logger', '$translate'];

    /* @ngInject */
    function PrincipalInvitedEntityData(logger, $translate) {
        PrincipalInvitedEntity.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getCountryLabel: getCountryLabel,
            getLangLabel: getLangLabel,
            getStatusLabel: getStatusLabel,
            getLegalId: getLegalId,
            getInvitedEntityNameWithId: getInvitedEntityNameWithId,
        };

        function PrincipalInvitedEntity(PrincipalInvitedEntityData) {
            if (!PrincipalInvitedEntityData) {
                this.buildEmpty();
            } else {
                this.build(PrincipalInvitedEntityData);
            }
        }

        return PrincipalInvitedEntity;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.legalEntityId = null;
            this.name = null;
            this.idFiscal = null;
            this.idNational = null;
            this.langCode = null;
            this.countryCode = null;
            this.status = null;
            this.invitation = null;
            this.relations = 0;
        }

        function build(PrincipalInvitedEntityData) {
            this.id = PrincipalInvitedEntityData.id || null;
            this.legalEntityId = PrincipalInvitedEntityData.legalEntityId || null;
            this.name = PrincipalInvitedEntityData.name || null;
            this.idFiscal = PrincipalInvitedEntityData.idFiscal || null;
            this.idNational = PrincipalInvitedEntityData.idNational || null;
            this.langCode = PrincipalInvitedEntityData.language || null;
            this.countryCode = PrincipalInvitedEntityData.countryCode || null;
            this.status = PrincipalInvitedEntityData.status || null;
            this.invitation = PrincipalInvitedEntityData.invitationId || null;
            this.relations = PrincipalInvitedEntityData.nbRelation || 0;
        }

        function getLangLabel() {
            return $translate.instant('lang.' + angular.lowercase(this.langCode));
        }

        function getStatusLabel() {
            if (this.status) {
                return $translate.instant('kiss_seller.status.' + angular.lowercase(this.status));
            }
            return '';
        }

        function getCountryLabel() {
            return $translate.instant('country.' + angular.lowercase(this.countryCode));
        }

        function getLegalId() {
            return this.idFiscal || this.idNational;
        }

        /**
         * Retourne le nom pour l'affichage dans la liste : name (Identifiant)
         */
        function getInvitedEntityNameWithId() {
            var name = this.name;
            if (this.idFiscal) {
                name += ' (' + this.idFiscal + ')';
            } else if (this.idNational) {
                name += ' (' + this.idNational + ')';
            }
            return name;
        }
    }
})();
